import * as THREE from 'three';
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../../utils/Functions';

const WindowModel = ({ windowWidth, windowHeight, trimColor, doorColor, glassTexture}) => {
    const deviation = 0.1
    const railThickness = 0.01;
    const railDistanceX = (windowWidth - deviation) / 3;

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2,  -windowHeight / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - deviation), -(windowHeight / 2 - deviation));
        hole.lineTo(-(windowWidth / 2 - deviation), (windowHeight / 2 - deviation));
        hole.lineTo((windowWidth / 2 - deviation), (windowHeight / 2 - deviation));
        hole.lineTo((windowWidth / 2 - deviation),  -(windowHeight / 2 - deviation));
        hole.closePath();

        model.holes.push(hole)

        return model;
    }, [windowHeight, windowWidth])

    
    const railModel = useMemo(() => {
        let model = [];

        const railLeft = new THREE.Shape();
        railLeft.moveTo(-(railDistanceX / 2 + railThickness / 2), -windowHeight / 2);
        railLeft.lineTo(-(railDistanceX / 2 + railThickness / 2), windowHeight / 2);
        railLeft.lineTo(-(railDistanceX / 2 - railThickness / 2), windowHeight / 2);
        railLeft.lineTo(-(railDistanceX / 2 - railThickness / 2),  -windowHeight / 2);
        railLeft.closePath();

        const railRight = new THREE.Shape();
        railRight.moveTo((railDistanceX / 2 + railThickness / 2), -windowHeight / 2);
        railRight.lineTo((railDistanceX / 2 + railThickness / 2), windowHeight / 2);
        railRight.lineTo((railDistanceX / 2 - railThickness / 2), windowHeight / 2);
        railRight.lineTo((railDistanceX / 2 - railThickness / 2),  -windowHeight / 2);
        railRight.closePath();

        const railMiddle = new THREE.Shape();
        railMiddle.moveTo(-windowWidth / 2, -railThickness / 2);
        railMiddle.lineTo(-windowWidth / 2, railThickness / 2);
        railMiddle.lineTo(windowWidth / 2, railThickness / 2);
        railMiddle.lineTo(windowWidth / 2, -railThickness / 2);
        railMiddle.closePath();

        model.push(railLeft);
        model.push(railRight);
        model.push(railMiddle);
        
        return model;
    }, [railDistanceX, windowHeight, windowWidth])
    
    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2,  -windowHeight / 2);
        model.closePath();

        return model;
    }, [windowHeight, windowWidth])
    
    return (
        <>
            <mesh name='glass-window-trim' position={[0, 0, 0.08]}>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.12, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <mesh name='glass-rail-model' position={[0, 0, 0.08]}>
                <extrudeGeometry args={[railModel, extrudeSettings(0.12, 0.025, 0.03, 0, 2)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.3} />
            </mesh>
            <mesh name='glass' position={[0, 0, 0.1]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.1)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>
            
        </>
    )
}

export default WindowModel